import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import facade from "../services/qwof/apiFacade";
import QuagganEmoji from "./QuagganEmoji.jsx";

function RegisterForm({ onSwitchToLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await facade.register(username, password);
      await login(username, password); // auto-login after register
      navigate("/");
    } catch (err) {
      setError("Registration failed. Username may already exist.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-panel">
      <h2 className="register-title">Create your account</h2>
      <form onSubmit={handleRegister}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="login-input"
          required
        />
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            style={{ paddingRight: 32 }}
            required
          />
          <span
            onMouseEnter={() => setShowPassword(true)}
            onMouseLeave={() => setShowPassword(false)}
            style={{
              position: "absolute",
              right: 10,
              top: "48%",
              transform: "translateY(-55%)",
              cursor: "pointer",
            }}
            aria-label="Show password while hovering"
          >
            👁
          </span>
        </div>
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Repeat password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="login-input"
            style={{ paddingRight: 32 }}
            required
          />
          <span
            onMouseEnter={() => setShowConfirmPassword(true)}
            onMouseLeave={() => setShowConfirmPassword(false)}
            style={{
              position: "absolute",
              right: 10,
              top: "48%",
              transform: "translateY(-55%)",
              cursor: "pointer",
            }}
            aria-label="Show password while hovering"
          >
            👁
          </span>
        </div>
        <button
          type="submit"
          className="login-btn"
          disabled={loading}
        >
          {loading ? "Registering..." : "Register"}
        </button>
        {error && (
          <>
            <div className="register-error">{error}</div>
            <QuagganEmoji type="failure" />
          </>
        )}
      </form>
      <p className="login-help-text">
        Already have an account?{" "}
        <a
          href="#login"
          onClick={(e) => {
            e.preventDefault();
            if (onSwitchToLogin) {
              onSwitchToLogin();
            }
          }}
        >
          Login here!
        </a>
      </p>
    </div>
  );
}

export default RegisterForm;
